/* !
 * recipes.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {

	// おすすめレシピ
	// 空のアイテムを消し込み
	document.querySelectorAll('.recipe-top-recommend-slider .__item').forEach(ele => {
		if (!ele.getElementsByTagName('a').length) { ele.remove(); }
	});
	// 調理時間とカロリーの小数点以下を削除
	document.querySelectorAll('.recipe-top-recommend-slider .rt_cf_crt_recipe_cf_r_cook_time, .recipe-top-recommend-slider .rt_cf_crt_recipe_cf_r_energy').forEach(ele => {
		ele.textContent = ele.textContent.replace(/\.0/, '');
	});
	if (document.querySelector('.recipe-top-recommend-slider')) {
		const splide_recommend = new Splide('.recipe-top-recommend-slider.splide', {
			type: 'loop',
			autoplay: false,
			speed: 500,
			arrows: true,
			pagination: true,
			paginationKeyboard: true,
			autoWidth: true,
			gap: '32px',
			focus: 'center',
			breakpoints: {
				768: {
					gap: '16px',
				}
			}
		});
		splide_recommend.mount();
	}

	// 定番レシピ 空のアイテムを消し込み
	document.querySelectorAll('.recipe-top-standard li').forEach(ele => {
		if (!ele.getElementsByTagName('a').length) { ele.remove(); }
	});

	// TOPPICK SPのみカルーセル
	if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop) {
		const splide_pickup = new Splide('.recipe-top-pickup-slider.splide', {
			type: 'loop',
			autoplay: false,
			speed: 500,
			arrows: true,
			pagination: true,
			paginationKeyboard: true,
			autoWidth: true,
			gap: '32px',
			focus: 'center',
			breakpoints: {
				768: {
					gap: '16px',
				},
			}
		});
		splide_pickup.mount();
	}


})(window.FUNCTIONS);